var Music = {
	node :null,
	current: 2048,
	audio:null,
	icon:null,
	isMuted:false,
	ambient: null,
	ambient_source: "",
	ambient_state: null,

	init: function() {
		$("#overlay").append(Quality.node);
		AppEvent.on(player, "placeReady", function(pe) { Music.placeReady(pe);});

		SpeechManager.prepareTip("PLAYER.VOLUME.MUTE", "TIPS");
		SpeechManager.prepareTip("PLAYER.VOLUME.UNMUTE", "TIPS");

//		Music.icon = Menu.prepIcon('fa-volume-up', TPL.lng("tips.volume", 'Głośność'), "HTML5.tips.volume");
		Music.icon = Menu.prepIconSvg('assets/speaker.svg', TPL.lng("tips.volume", 'Głośność'), "HTML5.tips.volume");
		
		if (window.PROJECT.settings['pdf/guide'] == 'on') 
			player.pdfguide = Menu.prepIconSvg('assets/pdf.svg', TPL.lng("tips.pdfguide", 'Przewodnik w PDF'), "HTML5.tips.pdfguide");

		AppEvent.on(player, "MENU.REBUILD", function() {
			//Music.icon.children('a').on('click', Music.toggle);
			Music.icon.children('a').on('click', Volume.toggleUI);

			if (window.PROJECT.settings['pdf/guide'] == 'on') {
				player.pdfguide.children('a').on('click', function() {
					window.open("/html5/pdf/guide.php?folder=" + player.folder, "_blank");
				});
			}
		});

		AppEvent.on(player, "VOLUME.SET", function() {
			if (Music.audio != undefined && Music.audio != null) {
				Music.audio.setVolume(Volume.currentMusicVolume());
			}
			if (Music.ambient != undefined && Music.ambient != null) {
				if (Music.ambient_state == "mute") {
					Music.ambient.fadeVolume(0);
				} else {
					if (Volume.currentAmbientVolume() > 0.2) {
						Music.ambient.fadeVolume(Music.audio != null ? 0.2 : Volume.currentAmbientVolume());
					} else {
						Music.ambient.fadeVolume(Volume.currentAmbientVolume());
					}
				}
			}
		});

		Music.mobileicon = $("<div class='mobileonly mobilemute'><i class='fa fa-volume-up fa-fw'></i></div>");
		$("#overlay").append(Music.mobileicon);

		Music.mobileicon.on('click', Music.toggle);
	},

	toggle: function() {
		Music.isMuted = !Music.isMuted;

		if (Music.isMuted) {
			//Music.icon.find("i").removeClass("fa-volume-up");
			//Music.icon.find("i").addClass("fa-volume-mute");
			Music.icon.find("a").html("<img src='assets/speaker-off.svg' width='25' aria-hidden='true'>");
//				Music.icon.find("a").html("<i class='fa fa-volume-mute'></i>");
			//<img src='" + glyph + "' width='25' aria-hidden='true'>
			Music.mobileicon.find("i").removeClass("fa-volume-up");
			Music.mobileicon.find("i").addClass("fa-volume-mute");

			//AppEvent.trigger(player, "SOUND.MUTED", {});
			Volume.setMuted();
		} else {
			//Music.icon.find("i").removeClass("fa-volume-mute");
			//Music.icon.find("i").addClass("fa-volume-up");
			Music.icon.find("a").html("<img src='assets/speaker.svg' width='25' aria-hidden='true'>");
			
			Music.mobileicon.find("i").removeClass("fa-volume-mute");
			Music.mobileicon.find("i").addClass("fa-volume-up");

			//AppEvent.trigger(player, "SOUND.UNMUTED", {});

			Volume.setDefault();
		}

		if (Music.audio) {
			Music.audio.setMuted(Music.isMuted);
		}
	},

	suppress: function(b) {
		if (b) {
			this.muteState = Volume.master.muted;
			Volume.setMuted();
		} else {
			if (!this.muteState) {
		//		Volume.master.muted = this.muteState;
				Volume.setDefault();
			}
		}
	},

	placeReady: function(pe) {
		var music;

		Tab.groups['volume'].disable();

		if (player.current.sound != undefined && player.current.sound != "") {			
			music = player.current.sound;
		} else if (player.current.parentplace != undefined && player.current.parentplace.sound != undefined && player.current.parentplace.sound != "") {
			music = player.current.parentplace.sound;
		}
		Music.ambient_state = null;
		if (player.current.ambient_state != undefined) Music.ambient_state = player.current.ambient_state;

		if (player.current.ambient != undefined && player.current.ambient != "") {		
			if (Music.ambient_source != player.current.ambient) {
				if (Music.ambient_source != "") {
					Music.ambient.pause();
					delete Music.ambient;
				}
				if (player.offline)
					Music.ambient_source = './app/' + player.current.ambient;
				else
					Music.ambient_source = player.current.ambient;

				Music.ambient = new AudioEffect(Music.ambient_source);
				Music.ambient.setVolume(Volume.currentAmbientVolume());//player.current.ambient_vol == undefined ? 0.2 : parseFloat(player.current.ambient_vol);
				Music.ambient.setMuted(Music.isMuted);
				Music.ambient.setLoop(true);
				Music.ambient.play();
			}
		}

		if (SpeechManager.hasSpeech()) {
			Music.mobileicon.css("bottom", "150px");
		} else {
			Music.mobileicon.css("bottom", "110px");
		}

		//console.log("MUSIC: " + music);
			/*
			if (Music.audio != null) {
				Music.audio.pause();
				delete Music.audio;
			}
			*/
		if (player.offline) music = "app/" + music;

		if (Music.lastmusic != music && music != "") {
			if (Music.audio != null) {
				Music.audio.pause();
				delete Music.audio;
				Music.audio = null;
				Music.lastmusic = "";
			}

			/*
			Music.audio = new Audio(music);
			Music.audio.volume = Volume.currentMusicVolume();//player.current.ambient_vol == undefined ? 0.2 : parseFloat(player.current.ambient_vol);
			Music.audio.muted = Music.isMuted;
			Music.audio.loop = (player.current.sound_noloop == undefined || player.current.sound_noloop == "0") ? true : false;
			*/

			if (music != null) {
				Music.audio = new AudioEffect(music);
				Music.audio.setVolume(Volume.currentMusicVolume());//player.current.ambient_vol == undefined ? 0.2 : parseFloat(player.current.ambient_vol);
				Music.audio.setMuted(Music.isMuted);
				Music.audio.setLoop((player.current.sound_noloop == undefined || player.current.sound_noloop == "0") ? true : false);

				//console.log("Ambient volume: " + Music.audio.volume);

				var promise;

				if (player.current.sound_start > 0 || player.current.sound_end > 0) {
					promise = Music.audio.playRange(player.current.sound_start, player.current.sound_end);
				} else {
					promise = Music.audio.play();
				}			

				promise.then(function() {
					Music.lastmusic = music;
				}).catch(function() {
					Music.disabledmusic = music;
					console.log("Can't play music");
				})
			}
		}

		Music.pingMute();
		//}
	},

	resumePlaying: function() {
		if (Music.audio != undefined && Music.audio != null) {
			if (Music.disabledmusic != undefined && Music.disabledmusic != Music.lastmusic) Music.lastmusic = Music.disabledmusic;
			Music.audio.play();
		}
	},

	pingMute: function() {
		if (Music.firstPing == undefined) {
			Music.icon.addClass("muteslow");
			Music.icon.addClass("bigmute");
			setTimeout(function() {Music.icon.removeClass("bigmute");}, 12000);
			Music.firstPing = true;
		}
	}
}

function VolBar(title, tab, trans) {
	if (trans == undefined) {
		trans = {
			"on": {
				"speak_symbol": "PLAYER.VOLUME.MUTE",
				"title": TPL.lng("tips.mutesounds", "Wyłącz dźwięk")
			}
		};
	}

	this.trans = trans;

	this.power = 1;
	this.muted = false;
	this.visibility = true;

	this.node = $("<div class='vol'>" + title + "<br><a href='javascript:void(null);' class='b on mute-btn speaks' title='" + trans.on.title + "' data-speak='" + trans.on.speak_symbol + "' data-speakgroup='TIPS'><i class='fa fa-volume-up'></i></a><div class='slide'><input type='range' min='0' max='1' step='0.02' class='volctl'></div><div class='clear'></div></div>");
	this.muteBtn = this.node.find(".mute-btn");
	this.muteIcon = this.node.find(".mute-btn i");
	this.slide = this.node.find(".volctl");

	this.tabmute = Volume.addBasicTab('volume', tab, this.node.find(".mute-btn"));
	this.tabslide = Volume.addBasicTab('volume', tab + 1, this.node.find(".volctl"));

	this.visible = function(v) {
		this.visibility = v;
		if (this.visibility) {
			this.node.show();
			Tab.enable("volume", this.tabmute.id);
			Tab.enable("volume", this.tabslide.id);
		}
		else {
			this.node.hide();
			Tab.disable("volume", this.tabmute.id);
			Tab.disable("volume", this.tabslide.id);
		}
	};

	this.val = function() {
		if (this.muted) return 0;
		return this.power;
	};

	this.ui = function() {
		return this.node;
	};

	this.isMuted = function() {
		return this.muted;
	};

	this.set = function(v) {
		if (v > 0) this.power = v;

		if ((v == 0 && !this.muted) || (v != 0 && this.muted)) {
			this.mute(!this.muted);
		}

		this.slide.val(v);

		AppEvent.trigger(player, "VOLUME.SET", {});	
	};

	this.mute = function(b) {
		this.muted = b;
		if (b) {
			this.set(0);
			this.muteBtn.html("<img src='assets/speaker-off.svg' width='20' aria-hidden='true' style='margin-top: -3px;'>");
			this.muteBtn.attr("data-speak", this.trans.off.speak_symbol);
			this.muteBtn.attr("title", this.trans.off.title);
			/*
			this.muteIcon.addClass("fa-volume-mute");
			this.muteIcon.removeClass("fa-volume-up");
			*/
			AppEvent.trigger(player, "SOUND.MUTED", {});
		} else {
			this.muteBtn.html("<i class='fa fa-volume-up'></i>");
			this.muteBtn.attr("data-speak", this.trans.on.speak_symbol);
			this.muteBtn.attr("title", this.trans.on.title);
			/*
			this.muteIcon.removeClass("fa-volume-mute");
			this.muteIcon.addClass("fa-volume-up");
			*/
			this.setDefault();
			AppEvent.trigger(player, "SOUND.UNMUTED", {});
		}
	};

	this.setDefault = function() {
		this.set(this.power);
	};

	this.muteBtn.on("click", $.proxy(function() {
		this.mute(!this.muted);
	}, this));

	this.slide.on("change", $.proxy(function() {
		this.set(this.slide.val());
	}, this));

	this.enableTabs = function(b) {
		if (b) {
			if (this.visibility) {
				Tab.enable("volume", this.tabmute.id);
				Tab.enable("volume", this.tabslide.id);
			}
		} else {
			Tab.disable("volume", this.tabmute.id);
			Tab.disable("volume", this.tabslide.id);
		}
	}

	setInterval($.proxy(function() {
		this.set(this.slide.val());
	}, this), 100);

	this.setDefault();
}

var Volume = {
	power: 1,

	init: function() {
		Volume.buildUI();
		AppEvent.on(player, "placeReady", function(pe) { Volume.placeReady(pe);});
	},

	addBasicTab: function(group, step, node, focus, keyboard) {
		
		var no = Tab.findById('volume', Music.icon.tab.id);

		return Tab.addAfter(group, no + step, {
			"focus": function(m) {
				m.node.addClass("focused");
				if (m.focus == undefined) m.node.focus();
				else m.focus.focus();
			},

			"blur": function(m) {
				m.node.removeClass("focused");
			},

			"keyboard": keyboard != undefined ? keyboard : function() {

			}

		}, {"node": node, "focus": focus});

	},

	buildUI: function() {
		Volume.ui = $("<div class='volume-bar'> <a href='javascript:void(null);' onclick='Volume.hideUI()' class='bclose speaks ttip' data-ttip='" + TPL.lng("tips.clicktoclose", 'Kliknij aby zamknąć') + "' data-speakgroup='TIPS' data-speak='PLAYER.CLOSE'>&times;</a></div>");
		Volume.master = new VolBar("", 1);
		Volume.music = new VolBar(TPL.lng("volume.music", "Muzyka"), 3, {"on": {"speak_symbol": "PLAYER.VOLUME.MUTE_MUSIC", "title": TPL.lng("tips.mutesounds.music", "Wyłącz dźwięk muzyki")}, "off":{"speak_symbol": "PLAYER.VOLUME.UNMUTE_MUSIC", "title": TPL.lng("tips.unmutesounds.music", "Włącz dźwięk muzyki")}});
		Volume.lektor = new VolBar(TPL.lng("volume.lektor", "Lektor"), 5, {"on": {"speak_symbol": "PLAYER.VOLUME.MUTE_LEKTOR", "title": TPL.lng("tips.mutesounds.lektor", "Wyłącz dźwięk lektora")}, "off": {"speak_symbol": "PLAYER.VOLUME.UNMUTE_LEKTOR", "title": TPL.lng("tips.unmutesounds.lektor", "Włącz dźwięk lektora")}});
		Volume.yt = new VolBar(TPL.lng("volume.yt", "YouTUBE"), 7, {"on": {"speak_symbol": "PLAYER.VOLUME.MUTE_YT", "title": TPL.lng("tips.mutesounds.music", "Wyłącz dźwięk YouTubes")}, "off": {"speak_symbol": "PLAYER.VOLUME.UNMUTE_YT", "title": TPL.lng("tips.unmutesounds.music", "Włącz dźwięk YouTubes")}});

		Volume.ui.append("<div class='clear'></div>");
		Volume.ui.append(Volume.master.ui());
		Volume.ui.append("<hr size='1' id='vdiv'>");
		Volume.ui.append(Volume.music.ui());
		Volume.ui.append(Volume.lektor.ui());
		Volume.ui.append(Volume.yt.ui());

		Volume.closeTab = Volume.addBasicTab('volume', 9, Volume.ui.find(".bclose"));

		this.enableTabs(false);

		$("#overlay").append(Volume.ui);

		SpeechManager.enableSpeech(".volume-bar", ".speaks", 0, "TOPMENU");

		AppEvent.on(player, "SOUND.UNMUTED", function() {
			if (!Volume.master.muted) {
				Music.icon.find("a").css("padding", "7px");
				Music.icon.find("a").html("<img src='assets/speaker.svg' width='25' aria-hidden='true' style='pointer-events:none;'>");				
				/*
				Music.icon.find("i").removeClass("fa-volume-mute");				
				Music.icon.find("i").addClass("fa-volume-up");
				*/
				Music.mobileicon.find("i").removeClass("fa-volume-mute");
				Music.mobileicon.find("i").addClass("fa-volume-up");
			}
		});

		AppEvent.on(player, "SOUND.MUTED", function() {
			if (Volume.master.muted) {
//				Music.icon.find("a").html("<i class='fa fa-volume-mute'></i>");
				Music.icon.find("a").css("padding", "0px");
				Music.icon.find("a").html("<img src='assets/speaker-off.svg' width='38' aria-hidden='true'>");
				/*
				Music.icon.find("i").removeClass("fa-volume-up");
				Music.icon.find("i").addClass("fa-volume-mute");
				*/
				Music.mobileicon.find("i").removeClass("fa-volume-up");
				Music.mobileicon.find("i").addClass("fa-volume-mute");			
			}
		});

		Volume.checkVisibility();
	},

	toggleMute: function(t) {
		if (t == undefined) Music.toggle();
	},

	setMuted: function() {
		Volume.master.mute(1);
	},

	setDefault: function() {
		Volume.master.setDefault();
	},

	toggleUI: function() {
		if (Volume.ui != undefined && Volume.ui.is(":visible")) {
			Volume.hideUI();
			Tab.groups['volume'].disable();

		} else {
			Volume.showUI();
			Tab.groups['volume'].enable();
		}
	},

	enableTabs: function(b) {
		if (!b) {
			Tab.disable("volume", Volume.closeTab.id);
			Volume.master.enableTabs(false);
			Volume.music.enableTabs(false);
			Volume.lektor.enableTabs(false);
			Volume.yt.enableTabs(false);
		} else {
			Tab.enable("volume", Volume.closeTab.id);
			Volume.master.enableTabs(true);
			Volume.music.enableTabs(true);
			Volume.lektor.enableTabs(true);
			Volume.yt.enableTabs(true);
		}
	},

	showUI: function() {
		if (Volume.ui == undefined) Volume.buildUI();
		Volume.ui.show();
		Music.icon.css("opacity", "0.1");
		this.enableTabs(true);
		AppEvent.trigger(player, "VOLUME.UI.SHOW", {});
	},

	hideUI: function() {
		Volume.ui.hide();
		Music.icon.css("opacity", "1");
		this.enableTabs(false);
		AppEvent.trigger(player, "VOLUME.UI.HIDE", {});
	},

	currentAmbientVolume: function() {
		var mt = player.current.ambient_vol == undefined ? 0.2 : parseFloat(player.current.ambient_vol);
//		var mt = player.current.ambient_vol == undefined ? 1 : parseFloat(player.current.ambient_vol);
		return mt * Volume.music.val() * Volume.master.val();
	},

	currentMusicVolume: function() {
		return Volume.music.val() * Volume.master.val();
	},

	currentTipVolume: function() {
		var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

		if (isSafari)
			return 0.04 * Volume.lektor.val() * Volume.master.val();
		else
			return 0.4 * Volume.lektor.val() * Volume.master.val();
	},

	currentSpeechVolume: function() {
		return Volume.lektor.val() * Volume.master.val();
	},

	currentYTVolume: function() {
		return (Volume.yt.val() * Volume.master.val()) * 100;
	},
/*
	set: function(v) {
		if (v > 0) Volume.power = v;

		if ((v == 0 && !Music.isMuted) || (v != 0 && Music.isMuted)) {
			Music.toggle();
			return;
		}

		$("#volctl").val(v);

		AppEvent.trigger(player, "VOLUME.SET", {});
	}
*/
	checkVisibility: function() {
		console.log("AMBIENT: " + player.current.ambient);
		if (player.current.ambient != undefined && player.current.ambient != "") Volume.music.visible(1);
		else Volume.music.visible(0);

		if (YTPlayer.playerCount > 0 || VideoManager.playerCount > 0) Volume.yt.visible(1);
		else Volume.yt.visible(0);

		if (!Volume.yt.visibility && !Volume.music.visibility) {
			Volume.lektor.visible(0);
			$("#vdiv").hide();
		} else {
			Volume.lektor.visible(1);
			$("#vdiv").show();
		}
	},

	placeReady: function(pe) {
		Volume.checkVisibility();
	}
}

PluginManager.add(Music);
PluginManager.add(Volume);